module.exports = __webpack_public_path__ + "1da6f278ea9e5412da0505fa652e7260.svg";


//////////////////
// WEBPACK FOOTER
// ./images/step3-green.svg
// module id = 1163
// module chunks = 0